module.exports = __webpack_public_path__ + "img/emoji_spritesheet_3.d76a9fcc.png";